<template>
  <div class="mb-5 pb-5">
    <div class="row mt-4">
      <div class="col">
        <Autocomplete
          v-model="filters.level"
          name="level"
          :items="levels"
          classe="col-13"
          label="Nível"
          placeholder="Selecione o nível"
        />
      </div>
      <div class="col">
        <Input
          label="Data Inicial"
          v-model="filters.data_ini"
          name="data_ini"
          type="date"
        />
      </div>
      <div class="col">
        <Input
          label="Data Final"
          v-model="filters.data_fim"
          name="data_fim"
          type="date"
        />
      </div>
      <div class="col">
        <Autocomplete
          v-model="filters.source"
          name="source"
          :items="sourceList"
          classe="col-13"
          label="Fonte"
          placeholder="Selecione a fonte"
        />
      </div>
      <div class="col">
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 filter-buttons">
        <button type="button" class="btn btn-success btn-sm" @click="carregar">
          <Icon type="fas" icon="search" color="white" />
        </button>
        <button type="button" class="btn btn-cancel btn-sm" @click="limpar">
          <Icon type="fas" icon="times" title="Limpar" />
        </button>
        <button type="button" class="btn btn-primary btn-sm" @click="marcarTodasComoLidas">
          <Icon type="fas" icon="check" title="Marcar todas como lidas" />
        </button>
      </div>
    </div>

    <div class="row mt-4" v-show="carregado">
      <div class="col-12 bot-table-wrapper">
        <DataTable
          name="Notificações do Bot"
          :headers="headers"
          :data="tableData"
          :pesquisa="true"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex align-items-center">
              <button
                v-if="item.lida === 'Não'"
                class="btn btn-success btn-sm"
                @click="marcarComoLida(item)"
                title="Marcar como lida"
              >
                <i class="fas fa-check"></i>
              </button>
              <span v-else class="text-success" title="Já lida">
                <i class="fas fa-check-circle"></i>
              </span>
            </div>
          </template>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import moment from 'moment';
import axios from 'axios';

import Icon from '../ui/Icon.vue';
import Autocomplete from '../ui/Autocomplete.vue';
import Input from '../ui/Input.vue';
import DataTable from '../ui/DataTable.vue';

const ALL_OPTION = { id: 'all', value: 'Todos' };
const defaultFilters = {
  level: ALL_OPTION,
  source: ALL_OPTION,
  data_ini: moment().subtract(6, 'days').format('YYYY-MM-DD'),
  data_fim: moment().format('YYYY-MM-DD'),
};

export default {
  name: 'BotNotificacoes',
  components: {
    Icon,
    Autocomplete,
    Input,
    DataTable,
  },
  data() {
    return {
      carregado: false,
      filters: { ...defaultFilters },
      levels: [
        { id: 'all', value: 'Todos' },
        { id: 'error', value: 'error' },
        { id: 'warning', value: 'warning' },
        { id: 'info', value: 'info' },
        { id: 'debug', value: 'debug' },
        { id: 'critical', value: 'critical' },
        { id: 'alert', value: 'alert' },
        { id: 'emergency', value: 'emergency' },
      ],
      sourceList: [],
      headers: [
        { text: 'Data/Hora', value: 'data_hora' },
        { text: 'Fonte', value: 'source' },
        { text: 'Nível', value: 'level' },
        { text: 'Código', value: 'code' },
        { text: 'Mensagem', value: 'message', sortable: false },
        { text: 'Contexto', value: 'context', sortable: false },
        { text: 'Lida', value: 'lida' },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
      rawData: [],
    };
  },
  computed: {
    tableData() {
      return this.rawData.map(item => ({
        id: item.id,
        data_hora: moment(item.created_at).format('DD/MM/YYYY HH:mm'),
        source: item.source || '-',
        level: item.level,
        code: item.code || '-',
        message: item.message,
        lida: item.read_at ? 'Sim' : 'Não',
        context: this.trataContexto(item.context),
        // actions handled via scoped slot
      }));
    },
  },
  mounted() {
    this.carregar();
  },
  methods: {
    limpar() {
      this.filters = { ...defaultFilters };
      this.carregar();
    },
    async carregar() {
      const params = {
        ...this.apiFilters(),
        per_page: 500,
      };
      try {
        $("#overlayer-loading").addClass("show-overlayer");
        const { data } = await api.get('/painel/bot/notificacoes/lista', { params });
        if (data && data.url) {
          const res = await axios.get(data.url, {
            withCredentials: false,
          });
          this.rawData = res.data || [];
        } else {
          this.rawData = data.data || [];
        }
        this.atualizaFontes();
        this.carregado = true;
      } catch (error) {
        let errorMessage = 'Erro ao carregar notificações do bot';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        window.showToastDanger('body', errorMessage);
      } finally {
        $("#overlayer-loading").removeClass("show-overlayer");
      }
    },
    atualizaFontes() {
      const set = new Set(this.rawData.map(i => i.source).filter(Boolean));
      const list = Array.from(set).map(s => ({ id: s, value: s }));
      // adiciona opção 'Todos' no topo
      this.sourceList = [{ id: 'all', value: 'Todos' }, ...list];
    },
    apiFilters() {
      const mapAll = (selected) => {
        if (!selected) return null;
        const id = (typeof selected === 'object') ? selected.id : selected;
        if (id === null || id === '' || id === 'all' || id === 'todos' || id === '*') return null;
        return id;
      };
      return {
        level: mapAll(this.filters.level),
        source: mapAll(this.filters.source),
        data_ini: this.filters.data_ini,
        data_fim: this.filters.data_fim,
      };
    },
    async marcarTodasComoLidas() {
      try {
        const ids = this.rawData.filter(i => !i.read_at).map(i => i.id);
        if (!ids.length) {
          window.showToastInfo('body', 'Não há notificações não lidas');
          return;
        }
        await api.put('/painel/bot/notificacoes/marcar-lidas', { ids });
        window.showToastSuccess('body', 'Notificações marcadas como lidas');
        this.carregar();
      } catch (error) {
        window.showToastDanger('body', 'Erro ao marcar notificações como lidas');
      }
    },
    trataContexto(context) {
      if (!context) return '-';
      // Se for objeto, tenta stringify "bonito"
      if (typeof context === 'object') {
        try {
          return JSON.stringify(context).substring(0, 200) + (JSON.stringify(context).length > 200 ? '...' : '');
        } catch (e) {
          return '-';
        }
      }
      // Se já é string grande, limita
      return context.length > 200 ? context.substring(0, 200) + '...' : context;
    },
    async marcarComoLida(item) {
      if (item.lida === 'Sim') return;
      try {
        await api.put(`/painel/bot/notificacoes/${item.id}/lida`);
        window.showToastSuccess('body', 'Notificação marcada como lida');
        // Atualiza somente o item no rawData para evitar recarregar tudo
        const idx = this.rawData.findIndex(r => r.id === item.id);
        if (idx >= 0) {
          this.$set(this.rawData[idx], 'read_at', moment().format());
        }
      } catch (error) {
        window.showToastDanger('body', 'Erro ao marcar notificação como lida');
      }
    },
  },
};
</script>

<style scoped>
/* Wrapper para garantir que a área da tabela tenha um tamanho mínimo e preencha a página */
.bot-table-wrapper {
  min-height: 65vh; /* altura mínima para preencher boa parte da tela */
  display: flex;
  flex-direction: column;
}

/* Faz a tabela ocupar o espaço vertical disponível dentro do wrapper */
.bot-table-wrapper .v-data-table {
  flex: 1 1 auto;
}

/* Ajuste opcional para cabeçalho/paginacao ficar separado se necessário */
.bot-table-wrapper .pagination {
  margin-top: 0;
}
</style>
